/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Type de transaction :\n- SALE : SALE\n- RENTAL : Location\n- LIFETIME_SALE : Viager\n- AUCTION_SALE : Vente aux enchères\n- OFF_PLAN_SALE : VEFA (vente en l\'état futur d\'achèvement)\n
 */
export const propertyTransactionTypeSchema = z.enum(["SALE", "RENTAL", "LIFETIME_SALE", "AUCTION_SALE", "OFF_PLAN_SALE"]).describe("Type de transaction :\n- SALE : SALE\n- RENTAL : Location\n- LIFETIME_SALE : Viager\n- AUCTION_SALE : Vente aux enchères\n- OFF_PLAN_SALE : VEFA (vente en l'état futur d'achèvement)\n")